/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMenuButton = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 10v12H2V10zm-2 2H4v8h9zm-2 5v2H6v-2zm0-4v2H6v-2zM22 2v6H2V2zm-2 2H4v2h16z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMenuButton as MenuButton };
